// See WEB-3113 - Hide Advanced Settings on Availability Tab
export const HARDCODED_SHOW_ADVANCED_SETTINGS = false;

// Remove this flag after v9.18.0 release
export const HARDCODED_SHOW_TOTALS_ON_SCHEDULING_PAGE_TOP_SECTION = false;

// See comment here https://bookjane.atlassian.net/browse/WEB-3624?focusedCommentId=37053
export const HARDCODED_SHOW_AUDIT_TRAIL_CSV_EXPORT_DISCLAIMER = false;
